async function sendAjaxRequest(method, url, dataType, data, success = ajaxResponseMessage, error = throwGenericError) {
  return await $.ajax({
    type: method,
    url: url,
    dataType: dataType,
    contentType: "application/json",
    data: method == 'GET' ? data : JSON.stringify(data),
    success: success,
    error: error
  });
}

function ajaxResponseMessage(response) {
  if (response) {
    if(response.error){
      this.message_type = "error";
      this.message_text.push(response.error)

      if(this.loading) {
        this.loading = false
      }
    }
    else {
      window.location.replace(response.path);                            
    }
  }
  else {
    this.loading = false;
  }
}

function throwGenericError(response) {
  response ? console.log(response) : console.log("Error");

  if(this.loading) {
    this.loading = false;
  }
}

export { sendAjaxRequest, ajaxResponseMessage, throwGenericError }
